import { css } from "lit";

export const standardMarkdownTheme = css`

.standard-markdown {
  
  a {
    color: #0366d6;
  }

  a:hover {
    color: #0056b3;
    text-decoration: underline;
  }

  img {
    display: block;
    max-width: 100%;
    margin-inline: auto;
  }

  p {
    margin-top: 0;
    margin-bottom: 1rem;
  }


/* roughly based on bs table style */
table.table {
	 margin: 0 0 15px 0;
	 border-collapse: collapse;
   width: 100%;

   th{
      text-align: -webkit-match-parent
    }
    td, th {
        border-width: 0 0 1px 0;
        padding: 3px 10px;
        border-style: solid;
        border-color: #ddd;
    }
}



}

`